import { render, staticRenderFns } from "./FollowupSettings.vue?vue&type=template&id=27bbf37c&scoped=true"
import script from "./FollowupSettings.vue?vue&type=script&lang=js"
export * from "./FollowupSettings.vue?vue&type=script&lang=js"
import style0 from "./FollowupSettings.vue?vue&type=style&index=0&id=27bbf37c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bbf37c",
  null
  
)

export default component.exports